// Crockford base32 ULID-style identifiers: time-sortable, URL safe, generated
// with Web Crypto so the same helper works in Node and in the browser.
const ALPHABET = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

export function newId(prefix?: string, now: number = Date.now()): string {
  let time = '';
  let t = now;
  for (let i = 0; i < 10; i++) {
    time = ALPHABET[t % 32] + time;
    t = Math.floor(t / 32);
  }
  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);
  let rand = '';
  for (const b of bytes) rand += ALPHABET[b % 32];
  const id = (time + rand).toLowerCase();
  return prefix ? `${prefix}_${id}` : id;
}

export const ID_PATTERN = /^[a-z0-9][a-z0-9_-]{2,79}$/;
